import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { loanTypeMap } from 'reducers/loanDetail.reducer'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { LockRateRestriction } from './LockRateRestriction'

interface IRules {
  relockRate: Record<string, string[]>
  lockExpWarning: Record<string, string[]>
}

const configs: Record<string, string> = {
  lockRateRestrictions: 'Lock Rate Restrictions in Loan Structure.',
  relockRate: '"ReLock Rate" is required in below channels and Loan Status.',
  lockExpWarning: 'Show Lock EXP as Red color in pipeline table.',
}

export const Rules = () => {
  const [loanGlobalStatus] = useSelector((state: any) => [state.loanGlobalStatus])

  const [isLoading, setLoading] = useState(true)
  const [isChanged, setChanged] = useState(false)
  const [data, setData] = useState<IRules>()

  useEffect(() => {
    getAdminConfig('secondaryMarketing')
      .then((v) => setData(v.rules))
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, loanType: string, value: string) => {
    if (!data) return
    const newData = cloneDeep(data) as any

    if (!loanType) newData[key] = value
    else newData[key][loanType] = value

    setData(newData)
    setChanged(true)
  }

  const onSubmit = () => {
    setLoading(true)
    setAdminConfig('secondaryMarketing', { rules: data })
      .then(() => {
        toast('Successfully saved!', { type: 'info' })
        setChanged(false)
      })
      .finally(() => setLoading(false))
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <SaveChanges show={isChanged} onSave={onSubmit} />

      {Object.keys(configs).map((key, index) => (
        <div className="mb-4">
          <p className="border-b-2 border-shade-blue w-full italic flex justify-between items-center mb-2">
            {index + 1}. {configs[key]}
          </p>

          {key == 'lockRateRestrictions' ? (
            <RenderInput
              Key="lockRateRestrictions"
              input={{
                inputType: 'custom',
                title: '',
                span: 'full',
                value: (data as any)?.[key],
                render: (value: any, onChange: Function) => <LockRateRestriction value={value} onChange={onChange} />,
              }}
              onChange={(_: string, value: any) => onChange(key, '', value)}
            />
          ) : (
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4">
              {Object.keys(loanTypeMap).map((loanType) => (
                <RenderInput
                  Key={`${key}${loanType}`}
                  input={{
                    inputType: 'multiselect',
                    options: loanGlobalStatus,
                    title: loanTypeMap[loanType],
                    value: (data as any)?.[key]?.[loanType],
                    defaultSelected: false,
                  }}
                  onChange={(_: string, value: any) => onChange(key, loanType, value)}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
